import Book1 from "../assets/Book-1.jpg";
import Book2 from "../assets/Book-2.jpg";
import Book3 from "../assets/Book-3.jpg";
import Book4 from "../assets/Book-4.jpg";
import Book5 from "../assets/Book-5.jpg";
import Book6 from "../assets/Book-6.jpg";
import Book7 from "../assets/Book-7.jpg";
import Kids1 from "../assets/Kids1.jpg";
import Kids2 from "../assets/Kids2.jpg";
import Kids3 from "../assets/Kids3.jpg";
import Kids4 from "../assets/Kids4.jpg";
import Kids5 from "../assets/Kids5.jpg";

export const adultBookCovers: Record<number, string> = {
  1: Book1,
  2: Book2,
  3: Book3,
  4: Book4,
  5: Book5,
  6: Book6,
  7: Book7,
  8: Book7,
};

export const adultBookColors: Record<number, string> = {
  1: "#4db2b2",
  2: "#f6851f",
  3: "#496dab",
  4: "#c33838",
  5: "#459246",
  6: "#88358f",
  7: "#001840",
  8: "#001840",
};

export const kidsBookCovers: Record<number, string> = {
  1: Kids1,
  2: Kids2,
  3: Kids3,
  4: Kids4,
  5: Kids5,
};

export const kidsBookColors: Record<number, string> = {
  1: "#512ba5",
  2: "#18964b",
  3: "#035b74",
  4: "#3c7bc0",
  5: "#f36600",
};

export const kidsBookTitles: Record<number, string> = {
  1: "Magic Village",
  2: "Jungle World",
  3: "Robo City",
  4: "Space Mission",
  5: "Time Travel",
};

const MAX_ADULT_BOOK_NUM = 7;
const MAX_KIDS_BOOK_NUM = 5;

export const DUPLICATE_GROUP_WARNING_TEXT =
  "Grupa o tej nazwie już istnieje, wybierz inną nazwę.";

export type BookmarkGroupData = {
  bookId: string;
  bookTitle: string;
  bookSubtitle?: string;
  bookCoverSrc?: string;
  primaryColor?: string;
  isAdultBook: boolean;
  sortOrder: number;
  bookmarks: ElectronicBookmark[];
};

export type BookmarkBookMeta = Omit<
  BookmarkGroupData,
  "bookId" | "bookmarks"
>;

export const isSupportedBook = (book: BookNew | KidsBook) =>
  "bookNum" in book
    ? book.bookNum >= 1 && book.bookNum <= MAX_ADULT_BOOK_NUM
    : book.num >= 1 && book.num <= MAX_KIDS_BOOK_NUM;

export const buildBookmarkBookMetaById = (visibleBooks: (BookNew | KidsBook)[]) => {
  const lookup = new Map<string, BookmarkBookMeta>();

  visibleBooks.forEach((book, index) => {
    if (!book.id) return;

    const isAdultBook = "bookNum" in book;

    lookup.set(book.id, {
      bookTitle: isAdultBook
        ? `English Unlocked ${book.bookNum}`
        : `English Unlocked ${book.num}`,
      bookSubtitle: isAdultBook ? undefined : kidsBookTitles[book.num],
      bookCoverSrc: isAdultBook
        ? adultBookCovers[book.bookNum]
        : kidsBookCovers[book.num],
      primaryColor: isAdultBook
        ? (adultBookColors[book.bookNum] ?? "#f6851f")
        : (kidsBookColors[book.num] ?? "#f6851f"),
      isAdultBook,
      sortOrder: index,
    });
  });

  return lookup;
};

export const buildBookmarkGroups = (params: {
  visibleBooks: (BookNew | KidsBook)[];
  purchasedBookIds: string[];
  bookmarks: ElectronicBookmark[];
  bookMetaById: Map<string, BookmarkBookMeta>;
}) => {
  const { visibleBooks, purchasedBookIds, bookmarks, bookMetaById } = params;
  const grouped = new Map<string, BookmarkGroupData>();

  visibleBooks.forEach((book, index) => {
    if (!book.id || !purchasedBookIds.includes(book.id)) return;

    const bookMeta = bookMetaById.get(book.id);
    if (!bookMeta) return;

    grouped.set(book.id, {
      bookId: book.id,
      ...bookMeta,
      sortOrder: index,
      bookmarks: [],
    });
  });

  bookmarks.forEach((bookmark) => {
    const bookMeta = bookMetaById.get(bookmark.bookId);

    if (!bookMeta) return;

    if (!grouped.has(bookmark.bookId)) {
      grouped.set(bookmark.bookId, {
        bookId: bookmark.bookId,
        ...bookMeta,
        bookmarks: [],
      });
    }

    grouped.get(bookmark.bookId)?.bookmarks.push(bookmark);
  });

  return Array.from(grouped.values())
    .map((group) => ({
      ...group,
      bookmarks: [...group.bookmarks].sort(
        (a, b) =>
          b.updatedAt - a.updatedAt ||
          a.groupName.localeCompare(b.groupName, "pl", {
            sensitivity: "base",
          }),
      ),
    }))
    .sort(
      (a, b) =>
        a.sortOrder - b.sortOrder ||
        a.bookTitle.localeCompare(b.bookTitle, "pl", {
          sensitivity: "base",
        }),
    );
};
